import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { FaCalendarAlt } from "react-icons/fa";

const CustomDatePicker = ({
  label,
  selected,
  onChange,
  placeholder,
  minDate,
  error,
}) => {
  const { t } = useTranslation();
  const localizePlaceholder = placeholder || `${t("select")} ${t("date")}`;

  return (
    <>
      <div>
        {label && (
          <label className="form-label fw-semibold">
            {label} <span className="text-danger">*</span>
          </label>
        )}
        <div className="position-relative">
          <DatePicker
            selected={selected}
            onChange={onChange}
            dateFormat="dd/MM/yyyy"
            placeholderText={localizePlaceholder}
            minDate={minDate}
            className="formInput"
            wrapperClassName="datepicker-wrapper"
          />
          <FaCalendarAlt className="calederIcon" />
        </div>

        {error && <span className="text-danger small">{error}</span>}
      </div>

      <style>{`
        .datepicker-wrapper {
          width: 100%;
        }
        .datepicker-wrapper .react-datepicker-wrapper {
          width: 100%;
        }
        .datepicker-wrapper .react-datepicker__input-container {
          width: 100%;
        }
        .datepicker-wrapper input {
          width: 100% !important;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 12px;
          fontSize: 15px;
          font-weight: 500;
        }
        .react-datepicker {
          font-family: Arial, sans-serif;
        }
          .react-datepicker__triangle{
          transform: translate3d(100px, 0px, 0px) !important;
          }
      `}</style>
    </>
  );
};

export default CustomDatePicker;
